import { FormattedMessage, useIntl } from 'react-intl';

import { useUser } from '@/modules/auth/hooks';
import { Label } from '@/modules/forms';
import { SelectField } from '@/modules/secrets/components/SecretForm/SelectField';
import { FormFieldWhitelist, useWhitelistUsers, type WhitelistUser } from '@/modules/whitelist';
import { AccessRole } from '@/types';

import { VaultFormField } from '../../../constants';
import { VAULT_ACCESS_ROLES } from '../../../utils';

const name = VaultFormField.USERS;

export const VaultUsersField = () => {
    const { formatMessage } = useIntl();

    const currentUser = useUser();

    const { api, data, handleLoadMore, handleSearch } = useWhitelistUsers();

    return (
        <SelectField<WhitelistUser>
            id={name}
            name={name}
            label={
                <Label>
                    <FormattedMessage id='secret.whitelistUsers.label' />
                </Label>
            }
            placeholder={formatMessage({ id: 'vaults.form.users.placeholder' })}
            // The API persists the creator as an editor regardless, so offering them a role it would
            // overrule is misleading. The record-sharing picker excludes the record's creator likewise.
            options={data
                .filter(user => user.id !== currentUser?.id)
                .map(user => ({
                    value: user.id,
                    key: user.id,
                    label: `${user.name} (${user.email})`,
                    entity: user,
                }))}
            onSearch={handleSearch}
            loading={api.inProgress}
            loadingMore={api.inProgressNext}
            onLoadMore={handleLoadMore}
            hasMore={Boolean(api.nextPageToken)}
            popupShouldIgnoreParentContainer
            defaultRole={AccessRole.VIEWER}
        >
            {(value, actions) => (
                <FormFieldWhitelist
                    value={value}
                    onUpdate={actions.onUpdate}
                    onRemove={actions.onRemove}
                    hasPasskey={false}
                    roles={VAULT_ACCESS_ROLES}
                />
            )}
        </SelectField>
    );
};
